import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess206201Status: 'idle',
    startProcess206201Error: undefined as any,
    loadUserParamsProcess206201Status: 'idle',
    loadUserParamsProcess206201Error: undefined as any,

    process206201List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess206201 = createAsyncThunk('process206201Slice/startProcess206201', async ({ process206201 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess206201/`,
        prepareData(process206201),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess206201Status } = getState().process206201Slice
        return startProcess206201Status !== 'pending'
    }
})

export const loadUserParamsProcess206201 = createAsyncThunk('process206201Slice/loadUserParamsProcess206201', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess206201/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess206201Status } = getState().process206201Slice
        return loadUserParamsProcess206201Status !== 'pending'
    }
})

const Process206201Slice = createSlice({
    name: 'process206201Slice',
    initialState,
    reducers: {
        resetstartProcess206201: (state) => {
            state.job = undefined
            state.startProcess206201Error = undefined
        },
        resetstartProcess206201Error: (state) => {
            state.startProcess206201Error = undefined
        },
        resetloadUserParamsProcess206201: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess206201Error = undefined
        },
        resetloadUserParamsProcess206201Error: (state) => {
            state.loadUserParamsProcess206201Error = undefined
        },
        removeFromProcess206201ListById: (state, action) => {
            state.process206201List = state.process206201List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess206201ListByIds: (state, action) => {
            state.process206201List = state.process206201List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process206201List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess206201Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process206201List = []
            state.startProcess206201Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess206201.pending, (state) => {
            state.startProcess206201Status = 'pending'
            state.startProcess206201Error = undefined
        })
        builder.addCase(startProcess206201.fulfilled, (state, action) => {
            state.startProcess206201Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess206201.rejected, (state, action) => {
            state.startProcess206201Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess206201Error = action.error.message
            } else {
                state.startProcess206201Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess206201.pending, (state) => {
            state.loadUserParamsProcess206201Status = 'pending'
            state.loadUserParamsProcess206201Error = undefined
        })
        builder.addCase(loadUserParamsProcess206201.fulfilled, (state, action) => {
            state.loadUserParamsProcess206201Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess206201.rejected, (state, action) => {
            state.loadUserParamsProcess206201Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess206201Error = action.error.message
            } else {
                state.loadUserParamsProcess206201Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess206201,
    resetstartProcess206201Error,
    resetloadUserParamsProcess206201,
    resetloadUserParamsProcess206201Error,
    removeFromProcess206201ListById,
    removeFromProcess206201ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process206201Slice.actions
export default Process206201Slice.reducer
